export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';
export const UPDATE_CUSTUMER_DATA = 'UPDATE_CUSTUMER_DATA';
